<template>
  <div v-if="passport"
       class="moderator-candidate-resumes-passports">
    <div class="moderator-candidate-resumes-passports__content">
      <AMCandidatesResumesPageResumePassportsItem v-for="(page, index) in passport"
                                                                :page="page"
                                                                :index="index"
                                                                :key="page.passport_page_id"/>
    </div>
  </div>
</template>

<script>
  import AMCandidatesResumesPageResumePassportsItem
    from './AMCandidatesResumesPageResumePassportsItem'
  import {mapState} from 'vuex'

  export default {
    name: 'AMCandidatesResumesPageResumePassports',
    components: {
      AMCandidatesResumesPageResumePassportsItem
    },
    data() {
      return {}
    },
    computed: {
      ...mapState('candidatesResumes', [
        'passport',
      ]),
    }
  }
</script>

<style lang="less">

</style>
